import { render, staticRenderFns } from "./ModalPswChange.vue?vue&type=template&id=90e8a5ec&scoped=true&"
import script from "./ModalPswChange.vue?vue&type=script&lang=js&"
export * from "./ModalPswChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e8a5ec",
  null
  
)

export default component.exports